import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import OnboardingJourney from '../components/OnboardingJourney';

// Geçici önizleme sayfası. Bölümü burada birlikte düzenleriz; beğenince
// <OnboardingJourney /> landing'e (LandingLab) taşınır, bu sayfa silinir.
export default function OnboardingJourneyPreview({ isDarkMode, toggleDarkMode }) {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">
      <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <main className="pt-24">
        <div className="mx-auto max-w-6xl px-4 pt-4">
          <p className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-center text-xs font-semibold text-amber-700 dark:border-amber-900/40 dark:bg-amber-900/10 dark:text-amber-300">
            İzole önizleme — bu bölüm artık landing'de de yayında (Premium Mutfaklar'ın üstünde). Burası sadece tek başına test/düzenleme içindir.
          </p>
        </div>
        <OnboardingJourney />
      </main>
      <Footer />
    </div>
  );
}
